import React from "react";

const SvgAlcopopBottle = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M120.5 69.5l-3-53.2H97l-3 53.2c-1 20-12.8 18.3-12.8 47.1v82.3h52.1v-82.3c0-28.8-11.8-27.2-12.8-47.1zm-18.8-48.3h11.1l2.7 47.9H99l2.7-47.9zm23.1 141H89.9v-41.3h34.9v41.3z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAlcopopBottle;